import { toWords } from 'number-to-words'

import {
  calculateCarbon,
  calculateArea,
  withDefaults
} from 'src/components/organisms/CarbonCalculator/helper'
import { CalculatorTab } from 'src/components/organisms/CarbonCalculator/types'

export const tileDescriptions: ({ quantity: number } & {
  land: string
  carbon: string
})[] = [
  {
    quantity: 1,
    land: 'Approx. 1/5 the area of a typical car parking space.',
    carbon: 'Approx. CO₂ from driving a medium-sized car for 1,111 km.'
  },
  {
    quantity: 2,
    land: 'Approx. 2/5 the area of a typical car parking space.',
    carbon: 'Approx. CO₂ from driving a medium-sized car for 2,222 km.'
  },
  {
    quantity: 3,
    land: 'Approx. 2/3 the area of a typical car parking space.',
    carbon: 'Approx. CO₂ from driving a medium-sized car for 3,333 km.'
  },
  {
    quantity: 5,
    land: 'Approx. the area of 1 typical car parking space.',
    carbon: 'Approx. CO₂ from 1 return flight between Auckland and Sydney.'
  },
  {
    quantity: 8,
    land: 'Approx. the area of 1.5 typical car parking spaces.',
    carbon: 'Approx. CO₂ from 2 return flights between Auckland and Sydney.'
  },
  {
    quantity: 10,
    land: 'Approx. the area of 2 typical car parking spaces.',
    carbon: 'Approx. CO₂ from 2 return flights between Auckland and Sydney.'
  },
  {
    quantity: 11,
    land: 'Approx. 1/8 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 3 return flights between Auckland and Sydney.'
  },
  {
    quantity: 13,
    land: 'Approx. 1/7 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 3 return flights between Auckland and Sydney.'
  },
  {
    quantity: 17,
    land: 'Approx. 1/5 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 4 return flights between Auckland and Sydney.'
  },
  {
    quantity: 23,
    land: 'Approx. 1/4 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 6 return flights between Auckland and Sydney.'
  },
  {
    quantity: 34,
    land: 'Approx. 2/5 the area of a tennis court.',
    carbon:
      'Approx. CO₂ from a typical household over 1 year (power, waste, travel).'
  },
  {
    quantity: 46,
    land: 'Approx. 1/2 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 1 return flight between Auckland and London.'
  },
  {
    quantity: 69,
    land: 'Approx. 3/4 the area of a tennis court.',
    carbon: 'Approx. CO₂ from 2 return flights between Auckland and London.'
  },
  {
    quantity: 90,
    land: 'Approx. the area of 1 tennis court.',
    carbon: 'Approx. CO₂ from 2 return flights between Auckland and London.'
  },
  {
    quantity: 138,
    land: 'Approx. the area of 1.5 tennis courts.',
    carbon: 'Approx. CO₂ from 4 return flights between Auckland and London.'
  },
  {
    quantity: 180,
    land: 'Approx. the area of 2 tennis courts.',
    carbon: 'Approx. CO₂ from 5 return flights between Auckland and London.'
  },
  {
    quantity: 207,
    land: 'Approx. the area of 2.5 tennis courts.',
    carbon: 'Approx. CO₂ from 6 return flights between Auckland and London.'
  },
  {
    quantity: 276,
    land: 'Approx. the area of 3 tennis courts.',
    carbon: 'Approx. CO₂ from 8 return flights between Auckland and London.'
  },
  {
    quantity: 302,
    land: 'Approx. 1/8 the area of a rugby field.',
    carbon: 'Approx. CO₂ from 9 return flights between Auckland and London.'
  },
  {
    quantity: 346,
    land: 'Approx. 1/7 the area of a rugby field.',
    carbon: 'Approx. CO₂ from 10 return flights between Auckland and London.'
  },
  {
    quantity: 403,
    land: 'Approx. 1/6 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 22 cars driving 20,000 km.'
  },
  {
    quantity: 484,
    land: 'Approx. 1/5 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 27 cars driving 20,000 km.'
  },
  {
    quantity: 605,
    land: 'Approx. 1/4 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 34 cars driving 20,000 km.'
  },
  {
    quantity: 807,
    land: 'Approx. 1/3 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 45 cars driving 20,000 km.'
  },
  {
    quantity: 1211,
    land: 'Approx. 1/2 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 67 cars driving 20,000 km.'
  },
  {
    quantity: 1614,
    land: 'Approx. 2/3 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 90 cars driving 20,000 km.'
  },
  {
    quantity: 1816,
    land: 'Approx. 3/4 the area of a rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 101 cars driving 20,000 km.'
  },
  {
    quantity: 2422,
    land: 'Approx. the area of 1 rugby field.',
    carbon: 'Approx. CO₂ from a fleet of 135 cars driving 20,000 km.'
  },
  {
    quantity: 4844,
    land: 'Approx. the area of 2 rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 269 cars driving 20,000 km.'
  },
  {
    quantity: 7266,
    land: 'Approx. the area of 3 rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 404 cars driving 20,000 km.'
  },
  {
    quantity: 9689,
    land: 'Approx. the area of 4 rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 535 cars driving 20,000 km.'
  },
  {
    quantity: 12111,
    land: 'Approx. the area of 5+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 673 cars driving 20,000 km.'
  },
  {
    quantity: 24221,
    land: 'Approx. the area of 10+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 1,346 cars driving 20,000 km.'
  },
  {
    quantity: 36332,
    land: 'Approx. the area of 15+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 2,018 cars driving 20,000 km.'
  },
  {
    quantity: 48443,
    land: 'Approx. the area of 20+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 2,691 cars driving 20,000 km.'
  },
  {
    quantity: 60554,
    land: 'Approx. the area of 25+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 3,364 cars driving 20,000 km.'
  },
  {
    quantity: 72664,
    land: 'Approx. the area of 30+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 4,037 cars driving 20,000 km.'
  },
  {
    quantity: 84775,
    land: 'Approx. the area of 35+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 4,710 cars driving 20,000 km.'
  },
  {
    quantity: 96886,
    land: 'Approx. the area of 40+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 5,383 cars driving 20,000 km.'
  },
  {
    quantity: 108997,
    land: 'Approx. the area of 45+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 6,055 cars driving 20,000 km.'
  },
  {
    quantity: 121107,
    land: 'Approx. the area of 50+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 6,728 cars driving 20,000 km.'
  },
  {
    quantity: 145329,
    land: 'Approx. the area of 60+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 8,074 cars driving 20,000 km.'
  },
  {
    quantity: 169550,
    land: 'Approx. the area of 70+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 9,419 cars driving 20,000 km.'
  },
  {
    quantity: 193772,
    land: 'Approx. the area of 80+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 10,765 cars driving 20,000 km.'
  },
  {
    quantity: 217993,
    land: 'Approx. the area of 90+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 12,111 cars driving 20,000 km.'
  },
  {
    quantity: 242215,
    land: 'Approx. the area of 100+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 13,456 cars driving 20,000 km.'
  },
  {
    quantity: 363322,
    land: 'Approx. the area of 150+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 20,185 cars driving 20,000 km.'
  },
  {
    quantity: 484429,
    land: 'Approx. the area of 200+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 26,913 cars driving 20,000 km.'
  },
  {
    quantity: 605536,
    land: 'Approx. the area of 250+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 33,641 cars driving 20,000 km.'
  },
  {
    quantity: 726644,
    land: 'Approx. the area of 300+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 40,369 cars driving 20,000 km.'
  },
  {
    quantity: 847751,
    land: 'Approx. the area of 350+ rugby fields.',
    carbon: 'Approx. CO₂ from a fleet of 47,097 cars driving 20,000 km.'
  }
]

type TileParams = {
  icon: string
  title: string
  description: string
}

export const getTileParams = (
  numberOfTrees: number,
  isMonthly = false
): TileParams[] => {
  const finalNumberOfTrees = isMonthly ? numberOfTrees * 12 : numberOfTrees

  if (finalNumberOfTrees > 5000) return []

  const descriptions = tileDescriptions
    .filter(sd => sd.quantity <= finalNumberOfTrees)
    .sort((a, b) => b.quantity - a.quantity)

  const matched = descriptions[0]

  if (!matched) return []

  const { formattedValue: carbonValue, unit: carbonUnit } = calculateCarbon(
    withDefaults({
      formTab: CalculatorTab.Stems,
      stems: finalNumberOfTrees
    })
  )
  const { formattedValue: formattedAreaValue, unit: areaUnit } =
    calculateArea(finalNumberOfTrees)

  return [
    {
      icon: '/img/icons/stat-carbon-2.svg',
      title: `Remove ${carbonValue} ${carbonUnit}`,
      description: matched?.carbon
    },
    {
      icon: '/img/icons/rebranded/land-forest-green.svg',
      title: `Restore ${formattedAreaValue} ${areaUnit} of land`,
      description: matched?.land
    },
    {
      icon: '/img/icons/stat-biodiversity.svg',
      title: 'Support biodiversity',
      description:
        'Create habitats for kererū, tūī, geckos, and other native species.'
    }
  ]
}

export const toWordsCapped = (
  value: string | number,
  upperLimit: number = 9
): string => {
  if (Number(value) <= upperLimit) {
    return toWords(value)
  }
  return String(value)
}
